import {SET_FAVORITES, CHECK_FAVORITE_OFFER, DELETE_FAVORITE_OFFERS,
        CHECK_ALL_FAVORITE_OFFERS} from '../constants/favorites';

const initialState = {
  count: 0,
  list: [],
};

const favoritesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FAVORITES:
      return {
        ...state,
        list: action.list.map(
          (o, index) => {
            o.is_checked=false;
            o.price_number=parseFloat(o.price_number);
            o.discount_price_number=parseFloat(o.discount_price_number);
            o.discount=parseInt(o.discount);
            o.author_id=o.user_created;
            return o;}
        ),
        count: action.count
      };
    case CHECK_FAVORITE_OFFER:
      return {
        ...state,
        list: state.list.map(o => o.id === action.id ? {...o, is_checked: !o.is_checked} : o)
      };
    case DELETE_FAVORITE_OFFERS:
      return {
        ...state,
        list: state.list.filter(o => !action.ids.includes(o.id))
      };
    case CHECK_ALL_FAVORITE_OFFERS:
      return {
        ...state,
        list: state.list.map(o => ({...o, is_checked: action.is_checked}))
      };
    default:
      return state;
  }
};

export default favoritesReducer;